<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15OxWQY/tc-custom/9781429984638.jpg?1737196286492" alt="This image is the cover for the book Winterland"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Winterland
      </h1>
      <p class="bookDescription body article font2">
        <p>"Timely, topical, and thrilling."-- <b>John Connolly</b><br/><br/>"A terrific read...completely involving."-- <b>George Pelecanos</b><br/><br/>"WINTERLAND sets a dramatically high benchmark for emerald noir. With all the operatic inevitability of Greek tragedy, it anatomises what greed has done to Ireland. A resonant, memorable and uncomfortable read."-- <b>Val McDermid</b><br/><br/>"This is the colossus of Irish crime fiction, what Mystic River did for Dennis Lehane, WINTERLAND should do for Alan Glynn, it is a noir masterpiece, the bar against which all future works will be judged."<br/>-- <b>Ken Bruen</b><br/><br/><i>Winterland</i> is a blistering unputdownable novel about power, lies and the corrupting influence of money. It is the first in a series on the dark and clandestine underside of globalization and announces a compelling new voice in contemporary crime writing.<br/><br/>The worlds of business, politics and crime collide when two men with the same name, from the same family, die on the same night—one death is a gangland murder, the other, apparently, a road accident. Was it a coincidence? That's the official version of events. But when a family member, Gina Rafferty, starts asking questions, this notion quickly unravels. <br/><br/>Devastated by her loss, Gina's grief is tempered, and increasingly fuelled, by anger—because the more she's told that it was all a coincidence, that gangland violence is commonplace, that people die on our roads every day of the week, the less she's prepared to accept it. Told repeatedly that she should stop asking questions, Gina becomes more determined than ever to find out the truth, to establish a connection between the two deaths—but in doing so she embarks on a path that will push certain powerful people to their limits...</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alan Glynn
      </h2>
      
      <p class="authorDescription body article"><P>ALAN GLYNN is a graduate of Trinity College. His first novel, <I>The Dark Fields</I>, is currently being produced by Universal Pictures.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?39f456b6